import {
  KEY_CTRL_LEFT,
  KEY_CTRL_RIGHT,
  KEY_CMD_LEFT,
  KEY_CMD_RIGHT,
} from '@/constants';

export default event => {
  return (
    event.ctrlKey ||
    event.metaKey ||
    [KEY_CTRL_LEFT, KEY_CTRL_RIGHT, KEY_CMD_LEFT, KEY_CMD_RIGHT].includes(
      event.code
    )
  );
};
